<template>
  <div class="featureList">
    <ul v-if="featureList.length">
      <li v-for="feature in featureList" :key="feature.key" :class="{ 'needsRested': needsRested(feature.key), 'isActive': isActive(feature.key) }">{{ feature.name }}</li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'

import sortByName from '@/helpers/sortByName'

import allFeatures from '@/data/features'

export default defineComponent({
  setup () {
    const character = inject('character')
    const computedCharacter = inject('computedCharacter')

    const featureList = computed(() => ([
      ...character.features.map((feature) => ({
        key: feature,
        ...allFeatures[feature]
      })),
      ...(computedCharacter.race.value.features || []).map((feature) => ({
        key: feature,
        ...allFeatures[feature]
      })),
      ...(computedCharacter.characterClass.value.features || []).map((feature) => ({
        key: feature,
        ...allFeatures[feature]
      }))
    ].sort(sortByName)))

    const needsRested = (key) => character.restedAbilitiesUsed[key]
    const isActive = (key) => character.activeEffects.includes(key)

    return {
      featureList,
      needsRested,
      isActive
    }
  }
})
</script>

<style lang="sass" scoped>
.featureList
  font-size: 90%
  ul
    list-style-type: none
    li
      &.needsRested
        text-decoration: line-through
      &.isActive
        font-weight: bold
      &::before
        content: '✦'
        display: inline-flex
        padding-right: 0.8rem
        font-weight: 400 !important
</style>
